import React from 'react';
import CourseTableContainer from './CourseTableContainer';
import BranchSwitchContainer from './BranchSwitchContainer';
import TableControlsContainer from './TableControlsContainer';


const Configurator = (props) => {
    return (
        <div className="section container">
            <div className="pagesize">
                <div className="course-configurator">
                    <p className="h3">Voraussetzung</p>
                    <p>Zweite Fremdsprache mindestens in den Klassenstufen 7 bis 10 <strong>durchgängig</strong> belegt</p>

                    <BranchSwitchContainer />
                    <CourseTableContainer />
                    <TableControlsContainer />
                    
                </div>
            </div>
        </div>
    );
}

export default Configurator;